module.exports = __webpack_public_path__ + "static/ClickedOthersYellow-7e3cb70050175ffe47641042c41067db.png";